import { MenuItem, Select } from '@material-ui/core'
import React, { useState } from 'react'
import {
  DELETE_USER,
  RESET_ERROR,
  RESET_PASSWORD,
} from '../services/users-actions'
import {
  DELETE_USER_LABELS,
  RESET_PASSWORD_LABELS,
  USERS_ACTIONS_LABELS,
} from '../services/users-constants'

import toString from 'lodash/toString'
import { useDispatch } from 'react-redux'
import { UserProfile } from 'types/userTypes'
import { useAppSelector } from 'utils/reduxHelpers'
import ConfirmModal from '../../../components/_shared/confirmModal/ConfirmModal'
import { USER_ROLES } from '../../../services/constants'
import { checkConnection } from '../../../services/root/root-service'

type ActionsDropdownProps = {
  user: UserProfile
  goToCustomer: (id: number, email: string) => void
  handleOpenSnackBar: (text: string) => void
}

const ActionsDropdown = ({
  user,
  goToCustomer,
  handleOpenSnackBar,
}: ActionsDropdownProps) => {
  const [openReset, setOpenReset] = useState(false)
  const [openDelete, setOpenDelete] = useState(false)
  const isAccountOwner = user.roleId === USER_ROLES.accountOwnerRole

  const dispatch = useDispatch()

  const error = useAppSelector((state) => state.usersReducer.error)

  const resetPassword = (id: number, onSuccess: () => void) =>
    dispatch(checkConnection(() => RESET_PASSWORD(id, onSuccess)))
  const deleteUser = (id: number, onSuccess: () => void) =>
    dispatch(checkConnection(() => DELETE_USER(id, onSuccess)))
  const resetError = () => dispatch(RESET_ERROR())

  const handleChange = (
    event: React.ChangeEvent<{
      name?: string | undefined
      value: unknown
    }>
  ) => {
    const { value, name } = event.target

    switch (value) {
      case USERS_ACTIONS_LABELS.goToCustomer:
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        goToCustomer(Number(name!), user.email)
        break
      case USERS_ACTIONS_LABELS.resetPassword:
        resetError()
        setOpenReset(true)
        break
      case USERS_ACTIONS_LABELS.deleteUser:
        resetError()
        setOpenDelete(true)
        break
      default:
        return
    }
  }

  const closeModal = () => {
    setOpenReset(false)
    setOpenDelete(false)
  }

  const onSuccess = () => {
    handleOpenSnackBar(
      openReset ? RESET_PASSWORD_LABELS.success : DELETE_USER_LABELS.success
    )

    closeModal()
  }

  return (
    <>
      <Select
        name={toString(user.id)}
        displayEmpty
        renderValue={() => USERS_ACTIONS_LABELS.selectAction}
        onChange={handleChange}
        value=""
        id="select-action-dropdown"
        fullWidth
      >
        <MenuItem value={USERS_ACTIONS_LABELS.goToCustomer}>
          {USERS_ACTIONS_LABELS.goToCustomer}
        </MenuItem>
        {user.organizationActive && (
          <MenuItem value={USERS_ACTIONS_LABELS.resetPassword}>
            {USERS_ACTIONS_LABELS.resetPassword}
          </MenuItem>
        )}
        {!isAccountOwner && (
          <MenuItem value={USERS_ACTIONS_LABELS.deleteUser}>
            {USERS_ACTIONS_LABELS.deleteUser}
          </MenuItem>
        )}
      </Select>
      <ConfirmModal
        isOpen={openReset}
        onClose={closeModal}
        onSubmit={() => resetPassword(user.id, onSuccess)}
        modalTitle={RESET_PASSWORD_LABELS.resetPassword}
        confirmText={RESET_PASSWORD_LABELS.resetPasswordText(user.id)}
        actionLabel={RESET_PASSWORD_LABELS.resetPassword}
        closeLabel={RESET_PASSWORD_LABELS.cancel}
        error={error}
      />
      <ConfirmModal
        isOpen={openDelete}
        name={USERS_ACTIONS_LABELS.deleteUser}
        onClose={closeModal}
        onSubmit={() => deleteUser(user.id, onSuccess)}
        modalTitle={DELETE_USER_LABELS.deleteUser}
        confirmText={DELETE_USER_LABELS.deleteUserText(
          `${user.firstName} ${user.lastName}`
        )}
        actionLabel={DELETE_USER_LABELS.deleteUser}
        closeLabel={DELETE_USER_LABELS.cancel}
        error={error}
      />
    </>
  )
}

export default ActionsDropdown
